import { logoutUrl, loginUrl, dashboardUrl, casesUrl } from 'config/baseUrl';

const to = url => window.location.assign(url);

export const toLogout = () => to(logoutUrl);

export const toLogin = () => to(loginUrl);

export const toDashboard = () => to(dashboardUrl);

export const toCases = () => to(casesUrl);
